/* eslint-disable no-useless-rename */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {useEffect, useMemo, useRef, useState} from 'react'
import clsx from 'clsx'
import {useDispatch, useSelector} from 'react-redux'

//components
// import WSButton from '_metronic/helpers/components/WSButton/WSButton'

//conatants

//css
import './QuickMessage.scss'
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'

import {useLocation} from 'react-router-dom'

import Select, {MenuListProps, components} from 'react-select'
///////////////working/////////////

import {Form, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap'
import React from 'react'
import CreatableSelect from 'react-select/creatable'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import MessageBoxV2 from '../../../../Components/MessageBoxV2'
import moment from 'moment-timezone'
import {CreateQuickAutomation, EditQuickAutomation} from '../automationSlice/AutomationSlice'

export const initialData = {
  title: '',
  status: true,
  rule: {value: 'anyMessage', label: 'Any message'},
  message: '',
  'mailto:email': '',
  incomingSMS: false,
  searchTerm: '',
}

const QuickResponsePopup = ({show, handleClose, selectedData}: any) => {
  const dispatch = useDispatch()

  const [sendData, setSendData] = useState<any>(initialData)
  const [sendDataError, setSendDataError] = useState<any>({})
  const [options, setOptions] = useState({
    webLink: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    customLanding: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    optOut: [
      {value: "Reply 'Stop' to opt-out ", label: 'Reply Stop'},
      {value: 'STOP:{stoptxt.cc/}', label: 'custom survey'},
    ],
  })

  const [rules, setRules] = useState([
    {
      value: 'anyMessage',
      label: 'Any message',
    },
    {
      value: 'messageStartsWith',
      label: 'Message starts with',
    },
    {
      value: 'messageContains',
      label: 'Message contains',
    },
    {
      value: 'messageEquals',
      label: 'Message equals',
    },
    {
      value: 'anyMessageOptOut',
      label: 'Any message, except opt-out',
    },
  ])

  const serchTeamsVisible = ['messageStartsWith', 'messageContains', 'messageEquals']

  useEffect(() => {
    if (!!selectedData)
      setSendData({
        ...selectedData,
        rule: rules?.find((data: {value: string}) => data?.value == selectedData?.rule),
        'mailto:email': selectedData.email || '',
      })
  }, [selectedData])

  const handleCancel = () => {
    setSendData(initialData)
    setSendDataError({})
    handleClose()
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    e.stopPropagation()

    let tempData: any = {}
    let tempErrors = {...sendDataError}

    tempData = {
      title: sendData?.title,
      status: sendData?.status,
      rule: sendData?.rule,
      searchTerm: sendData?.searchTerm,
      message: sendData?.message,
      incomingSMS: sendData?.incomingSMS,
      'mailto:email': sendData?.['mailto:email'],
      email: sendData?.['mailto:email'],
    }

    if (!tempData?.title) {
      tempErrors = {...tempErrors, title: 'Title is required'}
    }
    if (!tempData?.rule) {
      tempErrors = {...tempErrors, rule: 'Rule is required'}
    }
    if (!tempData?.searchTerm && serchTeamsVisible.includes(tempData?.rule?.value)) {
      tempErrors = {...tempErrors, searchTerm: 'Search Term is required'}
    }
    if (!tempData?.message) {
      tempErrors = {...tempErrors, message: 'Message is required'}
    }
    if (!!tempData?.incomingSMS && !tempData?.['mailto:email']) {
      tempErrors = {...tempErrors, ['mailto:email']: 'Email is required'}
    }

    if (!serchTeamsVisible.includes(tempData?.rule?.value)) {
      tempData = {...tempData, searchTerm: ''}
    }
    if (!tempData?.incomingSMS) {
      tempData = {...tempData, 'mailto:email': ''}
    }
    tempData = {...tempData, rule: tempData?.rule?.value}

    setSendDataError(tempErrors)
    if (Object.values(tempErrors || {}).every((x) => !x)) {
      if (sendData?._id) {
        tempData = {...tempData, id: sendData?._id}
        dispatch(EditQuickAutomation(tempData))
      } else {
        dispatch(CreateQuickAutomation(tempData))
      }
      handleCancel()
    }
  }

  return (
    <React.Fragment>
      <Modal
        show={show}
        onHide={async () => {
          handleCancel()
        }}
        className={`quickMessageModal ${show ? 'right' : 'left'} `}
        dialogClassName={`modal-dialog-centered mw-450px nopreviweQuickMessage`}
      >
        <div className='card w-100 rounded-0' id='kt_drawer_chat_messenger'>
          <div
            className='card-header pe-5 quick-message-header'
            id='kt_drawer_chat_messenger_header'
          >
            <div className='card-title'>
              <div className='d-flex justify-content-center flex-column me-3'>
                <a
                  href='#'
                  className='fs-4 fw-bolder text-gray-900 text-hover-primary m-0 lh-1'
                  style={{textDecoration: 'none', margin: '0px !important'}}
                >
                  New quick reply
                </a>
              </div>
            </div>

            <div className='card-toolbar'>
              <div
                className='btn btn-sm btn-icon btn-active-light-primary'
                id='kt_drawer_chat_close'
                onClick={async () => {
                  handleCancel()
                }}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
              </div>
            </div>
          </div>

          <form className='form quick-message-form' noValidate>
            <div className='card-body '>
              <div className='d-flex'>
                <div className='d-flex'>
                  <div className='QuickMsgLeft'>
                    <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                      <div className='mt-0'>
                        <label className='form-label'>Rule title</label>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder='Rule name'
                          value={sendData?.title}
                          onChange={(e: any) => {
                            setSendData({...sendData, title: e?.target?.value})
                            setSendDataError({...sendDataError, title: false})
                          }}
                        />
                      </div>
                      {sendDataError?.title && (
                        <span className='text-danger mt-2'>{sendDataError?.title}</span>
                      )}
                    </div>
                    <div className=' my-6'>
                      <label className='form-label'>Status</label>
                      <div className='d-flex align-items-center gap-4'>
                        <Form.Check
                          onChange={(e) => setSendData({...sendData, status: e?.target?.checked})}
                          checked={sendData?.status}
                          className='unsub-switch'
                          type='switch'
                          id='custom-switch'
                        />

                        <h6
                          style={{
                            fontWeight: 500,
                            margin: 0,
                          }}
                        >
                          Active
                        </h6>
                      </div>
                    </div>
                    <div className='mt-0'>
                      <label className='form-label'>Rule</label>
                      <Select
                        onChange={(e) => {
                          setSendData({...sendData, rule: e})
                          setSendDataError({...sendDataError, rule: false})
                        }}
                        value={sendData?.rule}
                        options={rules}
                      />
                      {sendDataError?.rule && (
                        <span className='text-danger mt-2'>{sendDataError?.rule}</span>
                      )}
                    </div>
                    {serchTeamsVisible.includes(sendData?.rule?.value) ? (
                      <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 my-6'>
                        <div className='mt-0'>
                          <div className='d-flex align-items-center gap-2'>
                            <label className='form-label mb-0'>Search term</label>
                            <OverlayTrigger
                              placement='right'
                              overlay={
                                <Tooltip id='search-term-tooltip'>
                                  You can add several terms separated by commas
                                </Tooltip>
                              }
                            >
                              <i className='fas fa-info-circle' style={{cursor: 'pointer', fontSize: '14px'}}></i>
                            </OverlayTrigger>
                          </div>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder='Input terms'
                            value={sendData?.searchTerm}
                            onChange={(e: any) => {
                              setSendData({...sendData, searchTerm: e?.target?.value})
                              setSendDataError({...sendDataError, searchTerm: false})
                            }}
                          />
                        </div>
                        {sendDataError?.searchTerm && (
                          <span className='text-danger mt-2'>{sendDataError?.searchTerm}</span>
                        )}
                      </div>
                    ) : null}

                    <div className='row mt-6 mb-2' data-kt-buttons='true'>
                      <MessageBoxV2
                        setError={setSendDataError}
                        error={sendDataError}
                        setUserMessage={setSendData}
                        userMessage={sendData}
                        options={options}
                        quickSms={true}
                        showSelect={['template', 'customfield', 'weblink']}
                        itQuickMessage={true}
                      />
                      {sendDataError?.message && (
                        <span
                          className='text-danger'
                          style={{
                            marginTop: '-12px',
                          }}
                        >
                          {sendDataError?.message}
                        </span>
                      )}

                      <div>
                        <div
                          className='col-12 form-check form-check-sm form-check-custom form-check-solid '
                          style={{marginTop: '0px !important'}}
                        >
                          <input
                            className='form-check-input me-5'
                            id='contact'
                            type={'checkbox'}
                            onChange={(e) => {
                              setSendData({
                                ...sendData,
                                incomingSMS: e?.target?.checked,
                                'mailto:email': '',
                              })
                              setSendDataError({...sendDataError, 'mailto:email': false})
                            }}
                            checked={sendData?.incomingSMS}
                          />
                          <label
                            htmlFor='contact'
                            style={{
                              fontSize: '14px',
                              fontWeight: '600',
                            }}
                          >
                            Forwards incoming SMS
                          </label>
                        </div>
                        {sendData?.incomingSMS ? (
                          <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 my-6'>
                            <div className='mt-0'>
                              <label className='form-label'>Email</label>
                              <input
                                type='text'
                                className='form-control form-control-lg form-control-solid'
                                placeholder='Enter email'
                                value={sendData?.['mailto:email'] || sendData?.email}
                                onChange={(e: any) => {
                                  setSendData({...sendData, 'mailto:email': e?.target?.value})
                                  setSendDataError({...sendDataError, 'mailto:email': false})
                                }}
                              />
                            </div>
                            {sendDataError?.['mailto:email'] && (
                              <span className='text-danger mt-2'>
                                {sendDataError?.['mailto:email']}
                              </span>
                            )}
                          </div>
                        ) : null}
                      </div>

                      <div className='mt-6'>
                        <div className='d-flex flex-start'>
                          <button
                            onClick={handleSubmit}
                            // disabled={data}
                            className='btn btn-sm btn-primary me-2 p-3 px-5 fw-500 me-2'
                          >
                            <span className='indicator-label'>Save</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default QuickResponsePopup
